<template>
  <div>
     <navbar></navbar>
      <slot />
  </div>
</template>

<script>
import navbar from '../components/navbar';
export default {
methods:{

},
components:{
    navbar
}
}
</script>

